import { Container, Typography, Box, Stack, Divider, List, ListItem ,Button} from "@mui/material"
import { withTheme } from "@emotion/react"
import React from "react";
import Grid from '@mui/material/Unstable_Grid2';
import BtnBack from "../../../Button/BtnBack";
import CITChip from "../../../Button/CITChip";
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Avatar from '@mui/material/Avatar';
import Card from '@mui/material/Card';
import { Link } from "react-router-dom";
import PyscIcon from '../../../../assets/pychologyIcon.svg'
import Location from '../../../../assets/location-filled.svg'
import Building from '../../../../assets/buildings.svg'
import Calendar from '../../../../assets/calendar.svg'
import FooterLinks from "../../../Includes/Footer/FooterLinks";


const subTitles = [
  { title: 'Care in Touch', image: Building },
  { title: 'Fremont, California', image: Location },
  { title: 'Posted 3 days ago', image: Calendar },
]

const descriptions = [
  { header: 'About Us', description: "We are a home health agency that does gives an extra pickle and goes beyond an extra mile to provide the best quality of service and give our best care to you and your loved ones during those times when you need it- WE BUILD LASTING TRUST AND DEPENDABILITY THROUGH HARD-WORK AND COMMITMENT" },
  { header: 'Role and responsibility', description: "We are seeking a licensed psychologist to join our mental health team. The ideal candidate will have a strong background in psychological assessment, counseling. and therapy, and research. They will be responsible for providing individual and group counseling to clients, conducting psychological assessments and evaluations, and developing treatment plans. In addition, they will be expected to participate in research studies, provide consultation to other mental health professionals, and contribute to the overall growth and development of our organization" },
]

const requirements = [
  {
    header: 'Responsibilities',
    data: ["Conduct psychological assessments and evaluations to diagnose mental health conditions",
      "Develop treatment plans based on assessment results",
      "Provide counseling and therapy to individuals, couples, families, and groups",
      "Participate in research studies to advance our understanding of human behavior and mental health disorders",
      "Provide consultation to other mental health professionals and organizations",
      "Maintain accurate and up-to-date client records and treatment plans",
      "Keep abreast of current research and developments in the field of psychology",
      "Attend meetings and conferences as required",
      "Contribute to the overall growth and development of our organization"
    ]
  },
  {
    header: 'Qualifications',
    data: ['Minimum of 2 years working experience',
      'Doctoral degree in psychology from an accredited institution',
      'Licensed or eligible for licensure as a psychologist in the state',
      'Strong background in psychological assessment and counseling',
      'Experience with a variety of therapeutic approaches',
      'Strong research skills and experience conducting research studies',
      'Excellent communication and interpersonal skills',
      'Ability to work effectively with individuals from diverse backgrounds',
      'Commitment to ongoing professional development'
    ]
  }

]

const recent = [ 
  { title:'Nurse',description:'Fulltime, minimum 2 years experience mid level'},
  { title:'General Doctor',description:'Fulltime, minimum 2 years experience mid level'},
  { title:'Cardiologist',description:'Fulltime, minimum 2 years experience mid level'},
  { title:'Dermatologist',description:'Fulltime, minimum 2 years experience mid level'},
  { title:'Specialist Doctor',description:'Fulltime, minimum 2 years experience mid level'}
]








const Job = (props) => {


  const JobDescription = (props) => {

    const theme = props.theme
  
    const RecentOpenings = (props) => {
  
      return (
        <Box  width="100%">
           <Typography fontFamily="Inter" fontWeight={'700'} fontSize={'24px'} lineHeight={'29.05px'} >Recent openings</Typography>
           {
              <Stack mt="24px" spacing="24px" direction="column">
                   {
                      recent.map((item,i) => (
                        <RecentOpeningItem key={i} theme={props.theme} title={item.title} description={item.description} />
                      ))
                   }
                     <Share/>
              </Stack>
           }
        </Box>
      )
    }
  
    const RecentOpeningItem = (props) => {
  
      return (
        <Stack spacing="4px" direction="column">
          <Typography fontFamily="Inter" fontWeight={'500'} fontSize={'16px'} lineHeight={'19.36px'} >{props.title}</Typography>
          <Typography width={'258px'} lineHeight={'14.52px'} sx={{ ...props.theme.typography.body, color: '#292727' }} >
            {props.description}
          </Typography>
        </Stack>
      )
    }
    
    const Share = () => {
      
      return (<Stack spacing="4px" direction="column">
          <Typography mb={'8px'} width={'258px'} lineHeight={'14.52px'} sx={{ ...theme.typography.body, color: '#292727' }} >
            {'Share this job:'}
          </Typography>
          <FooterLinks/>
        </Stack>
      )
    }
    
    const CardSubtitle = (props) => {
    
      return (
        <Stack direction="row" >
          {
            props.data.map((subtitle,i) => (
              <Stack key={i} px='16px' pt="8px" pb='8px' spacing={2} direction="row" alignItems="center">
                <Avatar src={subtitle.image} sx={{ width: "16px", height: '16px' }}></Avatar>
                <Typography sx={{ ...props.theme.typography.sideNav, color: '#292727' }} noWrap>{subtitle.title}</Typography>
              </Stack>
            ))
          }
        </Stack>
      )
    }


    const Description = (props) => {
      return (
        <Stack  key={props.index} spacing="24px" pt="24px" pb="24px" direction="column">
          <Typography fontFamily="Inter" fontWeight={'600'} fontSize={'14px'} lineHeight={'16.94px'} >{props.header}</Typography>
          <Typography lineHeight={'14.52px'} sx={{ ...props.theme.typography.bodyDescription, color: '#292727' }} >
            {props.description}
          </Typography>
        </Stack>
      )
    }


    const RequirementItem = (props) => {
      return <ListItem  lineheight={'14.52px'} sx={{ ...props.theme.typography.bodyDescription, color: '#292727' }}>{props.text}</ListItem>
    }

    const Requirements = (props) => {

      return (
        <>
          {
            requirements.map((requirement,i) => (
              <Stack key={i} spacing="0px" pt="24px" pb="24px" direction="column">
                <Typography lineHeight={'14.52px'} sx={{ ...props.theme.typography.bodyDescription, color: '#292727' }}  >{requirement.header}</Typography>
                <List >
                  {
                    requirement.data.map((item,i) => (
                      <Box key={i}>
                          <RequirementItem  index={i} theme={props.theme} text={item} />
                      </Box>
                    ))
                  }
                </List>
              </Stack>
            ))
          }
        </>
      )
    }

    return (
      <Box sx={{ width: '100%' }}>
        <Grid   direction= {{xs:'column',sm:'row'}} container rowSpacing="48px" columnSpacing={{ xs: "8px", sm: "16px", md: "48px" }}>
          <Grid xs={12} sm={8}>
            <Card sx={{ width: 'auto', padding: '8px', background: '#F8FBFF', borderRadius: '8px',
                       '&.MuiCard-root':{ boxShadow: '0px 4px 50px 0px rgba(0, 0, 0, 0.10) !important'}
                       }}>
              <Stack padding="16px" alignItems="center" justifyContent="space-between" direction="row">
                <CardHeader
                  avatar={
                    <Avatar src={PyscIcon} variant='square' sx={{ width: '48px', height: '48px' }} aria-label="job icon">
                    </Avatar>
                  }
                  title={<Typography sx={theme.typography.heading}>{'Psychologist'}</Typography>}
                  sx={{ padding: '0px' }}
                />
                <CITChip label="Full Time"></CITChip>
              </Stack>
              <Divider sx={{ margin: '20px' }} />
              <CardSubtitle theme={theme} data={subTitles} />
              <CardContent>
                {
                  descriptions.map((item,i) => (
                    <Box key={i}>
                       <Description    index={i}  theme={theme} header={item.header} description={item.description} />
                    </Box>
                  ))
                }
                <Requirements theme={props.theme} />
                <Typography lineHeight={'14.52px'} sx={{ ...props.theme.typography.bodyDescription, color: '#292727' }} >
                  If you are a highly motivated, compassionate psychologist with a passion for helping others, we encourage you to apply for this exciting
                  opportunity. We offer a competitive salary and benefits package, as well as opportunities for professional growth and development.
                </Typography>
              </CardContent>
              <CardActions  sx={{ paddingLeft: '16px', paddingRight: '16px', marginTop:'24px', marginBottom:'8px' }} disableSpacing>
                <Link to={`application`} style={{textDecoration: 'none'}}>
                  <Button   style={{  alignItems: 'center', display: 'flex', justifyContent: 'center',  color: '#fff', padding:'12px, 24px, 12px, 24px', ...theme.button.primary }}  >
                    Appy here
                  </Button>
                </Link>
              </CardActions>
            </Card>
          </Grid>
          <Grid xs={12} sm={4}>
            <RecentOpenings theme={theme} />
          </Grid>
        </Grid>
      </Box>
    );
  }

  return (

    <Container  sx={{ padding:'0px !important', marginBottom: "48px", py: '24px', alignItems: 'center', display: "flex", flexDirection: 'column' }} maxWidth="xl">
      <Stack spacing="48px" width="100%" justifyContent="start" alignItems="left" direction="column">
        <BtnBack height="56px" text={'Go back'} />
        <JobDescription theme={props.theme} />
      </Stack>
    </Container>

  )
}


export default withTheme(Job);